module.exports = require('../build/addons/MomentLocaleUtils');



//////////////////
// WEBPACK FOOTER
// ../~/react-day-picker/moment/index.js
// module id = 1976
// module chunks = 1